module.exports = "/images/contract-cht-page-5.jpg?235752ee3af7b0b740e82ac75a23de34";